'use client'

import { useRouter } from 'next/navigation'
import { useFormContext } from 'react-hook-form'

import { JoinType } from '@/entities/auth'
import { useAccountVerification } from '@/features/update-account'
import { useSession } from '@/shared/lib'
import { Button } from '@/shared/ui'

import { useSignUp } from '../api/sign-up'
import { convertFormValuesToSignUpHost } from '../model/converter'
import { useSignUpHostStore } from '../model/host-sign-up'
import { useSignUpHostCompleteStore } from '../model/host-sign-up-complete'
import { THostPayForm } from '../model/sign-up-form'

export const SignUpHostButton = () => {
  const session = useSession()

  const router = useRouter()

  const actions = useSignUpHostStore(state => state.actions)
  const completeActions = useSignUpHostCompleteStore(state => state.actions)

  const { accountTrigger } = useAccountVerification()
  const { trigger, getValues } = useFormContext<THostPayForm>()

  const { signUp } = useSignUp({
    joinType: JoinType.HOST,
    onSuccess: async () => {
      completeActions.updateComplete({
        surveyAvailable: true,
        signUpCompleteTime: new Date().toISOString(),
        verificationType: 'phone',
      })

      await session.update()

      router.push('/sign-up/host/complete')
    },
  })

  const handleSignUp = async () => {
    const isAccountVerificationCompleted = await accountTrigger()

    if (!isAccountVerificationCompleted) {
      return false
    }

    const isValid = await trigger()

    if (!isValid) {
      return
    }

    const hostPayFormValues = getValues()

    actions.updatePay(hostPayFormValues)

    const signUpData = convertFormValuesToSignUpHost()

    if (!signUpData) {
      return
    }

    signUp(signUpData)
  }

  return (
    <Button className="mt-15" size="large" fullWidth onClick={handleSignUp}>
      회원가입 완료하기
    </Button>
  )
}
